import { createContext } from 'react'

export const InspectorContext = createContext({
  disabled: false,
})
